import moment, { Moment } from "moment";

import DateConverter from "../../converters/date_converter";

import type { DateLike } from "type_aliases";

export function toDomainDate(val: Moment | DateLike): Date {
  if (typeof val === "string") {
    if (DateConverter.isValidDateString(val)) {
      return DateConverter.localDateToDate(val);
    } else {
      return moment(val, "MMM D, YYYY").toDate();
    }
  } else if (val instanceof Date) {
    return val;
  } else if (moment.isMoment(val)) {
    return val.toDate();
  } else if (typeof val === "number") {
    return DateConverter.instantToDate(val) || DateConverter.millisecondsToDate(val) || null;
  } else {
    return null;
  }
}

function addDateGetterAndSetterToDomainModel(target: object, propertyName: string, constructorValue?: Moment | DateLike) {
  let dateVal;
  Object.defineProperty(target, propertyName, {
    get() {
      return dateVal;
    },
    set(val) {
      // As before bigBimViewerPerformance (which uses toDomainDate, where a Moment converts).
      if (typeof val === "string") {
        if (DateConverter.isValidDateString(val)) {
          dateVal = DateConverter.localDateToDate(val);
        } else {
          dateVal = moment(val, "MMM D, YYYY").toDate();
        }
      } else if (val instanceof Date) {
        dateVal = val;
      } else if (moment.isMoment(val)) {
        val.toDate();
      } else if (typeof val === "number") {
        dateVal = DateConverter.instantToDate(val) || DateConverter.millisecondsToDate(val) || null;
      } else {
        dateVal = null;
      }
    },
    enumerable: true,
    configurable: true
  });

  target[propertyName] = constructorValue;
}

export default addDateGetterAndSetterToDomainModel;
